import { Injectable } from '@angular/core';

import {
    FieldTypes
} from '@shared/service-proxies/service-proxies';

import moment from 'moment';

@Injectable()
export class TypeHelperService {


    constructor( ) { }


    getFieldType(field: any): number {
        const type = typeof field;

        if (field instanceof Date || moment.isMoment(field)) {
            return FieldTypes.Date;
        }

        switch (type) {
            case 'number':
                return FieldTypes.Number;
                break;
            case 'string':
                return FieldTypes.Text;
            default:
                return FieldTypes.Text;
        }

        return FieldTypes.Text;
    }
}
